module.exports = __webpack_public_path__ + "static/media/apercu-regular.19f5125a.woff";